import { ROUTE_TRADER } from '@klear/constants'

export function adminTraderIdFromPathname(pathname: string, basePath: string): string | null {
  const rest = basePath && pathname.startsWith(basePath) ? pathname.slice(basePath.length) : pathname
  const segments = rest.split('/').filter(Boolean)
  if (segments[0] !== ROUTE_TRADER) return null
  const traderId = segments[1]
  return traderId && /^\d+$/.test(traderId) ? traderId : null
}
